import type { DashboardQuery, WidgetId } from '@/data-sources/contract';
import { api, overrideExisting } from '@/store/api/api';
import { fromSource, type Sourced } from '@/store/api/fromSource';
import { tag } from '@/store/api/tags';

export type WidgetArgs = { id: WidgetId; query: DashboardQuery; params?: unknown };

export const widgetsApi = api.injectEndpoints({
  overrideExisting,
  endpoints: (build) => ({
    widget: build.query<unknown, Sourced<WidgetArgs>>({
      queryFn: fromSource((source, { id, query, params }, ctx) => {
        const load = source.widgets[id] as (req: { query: DashboardQuery; params: unknown }, c: typeof ctx) => Promise<unknown>;
        return load({ query, params }, ctx);
      }),
      providesTags: (_r, _e, arg) => [tag('Widget', arg.source), tag('Widget', arg.source, arg.params.id)],
      keepUnusedDataFor: 300,
    }),
  }),
});
